import { WEBFORM_GET_INFO_LOADED, WEBFORM_GET_LOADED } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/Webform';
import { fromJS } from 'immutable';
import { WEBFORM_UNLOAD } from '../../actions/Webform';

const initialState = fromJS({});

export default function webform(state = initialState, action = {}) {
  switch (action.type) {
    case WEBFORM_GET_LOADED: {
      return state.setIn([action.webform_id, 'fields'], fromJS(action.data));
    }

    case WEBFORM_GET_INFO_LOADED: {
      return state.setIn([action.webform_id, 'info'], fromJS(action.data));
    }

    case WEBFORM_UNLOAD: {
      return initialState;
    }

    default:
      return state;
  }
}
